<div class="wallet-avatar-container {{ size() }}" [class.failed]="failed()">
  @if (!failed()) {
    <img
      loading="lazy"
      [src]="imgSrc()"
      alt=""
      [style.filter]="imgFilter()"
      (error)="onImageError()"
    />
  }
</div>
